export default "__VITE_ASSET__CTEsRF0f__"